import { Menu } from 'lucide-react';

/**
 * Shared hamburger button used to open the mobile/tablet sidebar drawer.
 * Extracted from the duplicated header markup in DashboardLayout, MapPage,
 * and Analytics — keep this the single source of truth for that button's
 * classes/icon so the three headers stay visually consistent.
 */
const MobileMenuButton = ({ onClick, className = '', ariaLabel = 'Toggle menu' }) => (
  <button
    type="button"
    onClick={onClick}
    className={`flex items-center justify-center w-[36px] h-[36px] sm:w-[40px] sm:h-[40px] rounded-[8px] bg-[#E8EDEA] dark:bg-[#282a29] hover:bg-[#DCE1DE] dark:hover:bg-[#282a29]/80 transition-colors ${className}`}
    aria-label={ariaLabel}
  >
    <Menu size={20} className="text-[#282A29] dark:text-[#f0f5f2] sm:w-6 sm:h-6" />
  </button>
);

export default MobileMenuButton;
